/* unplugin-vue-components disabled */import { render } from "./feed-calendar.vue?vue&type=template&id=19511cd4&scoped=true"
import script from "./feed-calendar.vue?vue&type=script&lang=js"
export * from "./feed-calendar.vue?vue&type=script&lang=js"

import "./feed-calendar.vue?vue&type=style&index=0&id=19511cd4&lang=stylus&scoped=true"
import "./feed-calendar.vue?vue&type=style&index=1&id=19511cd4&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19511cd4"],['__file',"src/pages/pulse/feed/feed-calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19511cd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19511cd4', __exports__)) {
    api.reload('19511cd4', __exports__)
  }
  
  module.hot.accept("./feed-calendar.vue?vue&type=template&id=19511cd4&scoped=true", () => {
    api.rerender('19511cd4', render)
  })

}


export default __exports__